<nz-alert
  [nzBanner]="banner"
  [nzMessage]="message"
  [nzDescription]="description"
  [nzCloseable]="closeable"
  [nzShowIcon]="showIcon"
  [nzType]="type"
  (nzOnClose)="nzOnClose($event)"
></nz-alert>
